import { render, staticRenderFns } from "./BaseWistiaLoader.vue?vue&type=template&id=b791ea70&"
import script from "./BaseWistiaLoader.vue?vue&type=script&lang=js&"
export * from "./BaseWistiaLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports